import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Typography, { VARIANTS } from '@jobcase/react_pattern_library/components/Typography/TypographyRebrand';

const ListObjectTitle = styled.div`
  > div {
    font-weight: 500;
  }
`;

const DynamicDropdownListObject = ({ option }) => (
  <Typography variant={VARIANTS.BODY} hovered={option.hovered}>
    {option.selected ? (
      <>
        <span className="left-rail" />
        <ListObjectTitle>
          {option.title}
        </ListObjectTitle>
      </>
    ) : (
      <div>{option.title}</div>
    )}
  </Typography>
);

DynamicDropdownListObject.propTypes = {
  option: PropTypes.shape({
    hovered: PropTypes.bool,
    selected: PropTypes.bool,
    title: PropTypes.node,
  }),
};

DynamicDropdownListObject.defaultProps = {
  option: {},
};

export default DynamicDropdownListObject;
